(function () {
    'use strict';

    var gettext = angular.identity;

    angular
        .module('app.gameTracker')
        .enumeration('gameTrackCategory', {
            Summary: { displayName: gettext('Summary'), state: 'scoring.game-tracker.summary' },
            Scoring: { displayName: gettext('Scoring'), state: 'scoring.game-tracker.scoring' },
            GreensInRegulation: { displayName: gettext('Greens In Regulation'), state: 'scoring.game-tracker.gir' },
            DrivingAccuracy: { displayName: gettext('Driving Accuracy'), state: 'scoring.game-tracker.driving' },
            Putting: { displayName: gettext('Putting'), state: 'scoring.game-tracker.putting' },
            Recovery: { displayName: gettext('Recovery'), state: 'scoring.game-tracker.recovery' },
            ParPerformance: { displayName: gettext('Par Performance'), state: 'scoring.game-tracker.par' }
        })
        .enumeration('gameTrackRange', createGameTrackRange())
        .enumeration('holeSummaryStatisticType', {
            Par: { displayName: gettext('Par'), fieldName: 'par' },
            AverageScore: { displayName: gettext('Avg. Score'), fieldName: 'averageScore' },
            AveragePutts: { displayName: gettext('Avg. Putts'), fieldName: 'averagePutts' },
            TotalEagles: { displayName: gettext('Total Eagles'), fieldName: 'totalEagles' },
            TotalBirdies: { displayName: gettext('Total Birdies'), fieldName: 'totalBirdies' },
            TotalPars: { displayName: gettext('Total Pars'), fieldName: 'totalPars' },
            TotalBogeys: { displayName: gettext('Total Bogeys'), fieldName: 'totalBogeys' },
            TotalDoubles: { displayName: gettext('Total Doubles'), fieldName: 'totalDoubles' },
            TotalDoublesPlus: { displayName: gettext('Total Doubles +'), fieldName: 'totalDoublesPlus' },
            TotalPenalties: { displayName: gettext('Total Penalties'), fieldName: 'totalPenalties' }
        })

        .enumeration('summaryItemType', {
            // Scoring
            Albatross: { displayName: gettext('Albatross'), color: '#97BBCD' },
            Eagles: { displayName: gettext('Eagles'), color: '#DCDCDC' },
            Birdies: { displayName: gettext('Birdies'), color: '#F7464A' },
            Pars: { displayName: gettext('Pars'), color: '#46BFBD' },
            Bogeys: { displayName: gettext('Bogeys'), color: '#FDB45C' },
            Doubles: { displayName: gettext('Doubles'), color: '#949FB1' },
            Other: { displayName: gettext('Other'), color: '#4D5360' },

            // Greens in Regulation
            GirHit: { displayName: gettext('GIR'), color: '#97BBCD' },
            GirMissed: { displayName: gettext('Missed'), color: '#DCDCDC' },

            // Driving Accuracy
            FirHit: { displayName: gettext('FIR'), color: '#97BBCD' },
            FirLeft: { displayName: gettext('Missed Left'), color: '#DCDCDC' },
            FirRight: { displayName: gettext('Missed Right'), color: '#F7464A' },
            FirLong: { displayName: gettext('Missed Long'), color: '#46BFBD' },
            FirShort: { displayName: gettext('Missed Short'), color: '#FDB45C' },
            FirOther: { displayName: gettext('Missed Other'), color: '#949FB1' },
            FirUnknown: { displayName: gettext('Not Recorded'), color: '#4D5360' },

            // Putting
            PuttsTotal: { displayName: gettext('Total Putts'), color: '#97BBCD' },
            PuttsPerHole: { displayName: gettext('Putts Per Hole'), color: '#DCDCDC' },
            PuttsProximity: { displayName: gettext('Proximity'), color: '#F7464A' },

            // Recovery
            Scrambling: { displayName: gettext('Scrambling'), color: '#97BBCD' },
            UpDown: { displayName: gettext('Up & Downs'), color: '#DCDCDC' },
            SandSave: { displayName: gettext('Sand Saves'), color: '#F7464A' },
            BounceBack: { displayName: gettext('Bounce Backs'), color: '#FDB45C' },

            // Par Performance
            ParThreeAverage: { displayName: gettext('Par 3 Average'), color: '#97BBCD' },
            ParFourAverage: { displayName: gettext('Par 4 Average'), color: '#DCDCDC' },
            ParFiveAverage: { displayName: gettext('Par 5 Average'), color: '#F7464A' },
        })

    function createGameTrackRange() {
        var currentYear = new Date().getFullYear();
        return []
            .concat(
                { value: 'Last20', displayName: gettext('Last 20 Rounds') },
                { value: 'Last5', displayName: gettext('Last 5 Rounds') },
                { value: 'YTD', displayName: gettext('Year-To-Date') },
                Array.from({ length: 5 }, function (v, i) { return { value: (currentYear - i).toString() } }),
                { value: 'Career', displayName: gettext('Career') }
            )
            .reduce(function (acc, value) { return (acc[value.value] = value) && acc; }, {});
    }
})();